"use strict";

(function () {
  'use strict';

  function LoginCtrl($state, LRNotification) {
    var vm = this;

    this.currentState = function () {
      return $state.current.name;
    };
  }

  LoginCtrl.$inject = ['$state', 'LRNotification'];
  angular.module('view.login', ['ui.router']).config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('login-base', {
      template: '<login />',
      title: 'Login'
    });
    $stateProvider.state('login', {
      parent: 'login-base',
      url: '/login?error&returnto',
      template: '<login-form />',
      title: 'Login'
    });
    $stateProvider.state('login-sign-up', {
      parent: 'login-base',
      url: '/sign-up',
      template: '<sign-up />',
      title: 'Sign Up'
    });
    $stateProvider.state('login-account-verify', {
      parent: 'login-base',
      url: '/account-verify?errMsg&successMsg',
      template: '<account-verify />',
      title: 'Account Verify'
    });
    $stateProvider.state('login-password-reset', {
      parent: 'login-base',
      url: '/password-reset?reset_token&errMsg&successMsg',
      template: '<password-reset />',
      title: 'Password Reset'
    });
    $stateProvider.state('login-complete-account-setup', {
      parent: 'login-base',
      url: '/complete-account-setup?reset_token&errMsg&successMsg&returnto',
      template: '<password-reset />',
      title: 'Complete Account Setup'
    });
  }]).component('login', {
    bindings: {},
    controller: LoginCtrl,
    templateUrl: 'views/login/login.html'
  });
})();